<span
  *ngIf="type"
  class="badge lg"
  [ngStyle]="{ 'background-color': type.color, color: type.invertColor }"
  [style.borderColor]="type.color ? 'transperant' : '#939494'"
>
  {{ type.value }}
</span>
